<script lang="ts" setup>
</script>

<template>
  <div v-once>
    <div class="document-page">
      <h1 class="text-center">开放原子开源基金会品牌使用指南</h1>
      <p class="text-center">版本号: 2.0</p>
      <p class="text-center">发布时间: 2022年6月7日</p>
      &emsp;&emsp;开放原子开源基金会（以下称“本基金会”）作为中立、开放、非营利的慈善组织，享有本基金会及旗下各项目（群）相关知识产权及合法权益，包括但不限于与本基金会及旗下各项目（群）相关的所有商标和字号（以下称
      “<b class="smallHand"><a href="https://res.oafimg.cn/-/74491fba19f02e78/trademarks.xlsx">本基金会品牌</a></b>”）。
      <p>
        &emsp;&emsp;为维护本基金会品牌的合法商誉和品牌价值，特拟制并公示《开放原子开源基金会品牌使用指南》（以下称“本指南”），希望与所有参与开源生态的贡献者和社区伙伴（以下称“您”）共同合法、规范地使用本基金会品牌。
      </p>
      <h4>1.使用情形</h4>
      <h4>1.1.无须本基金会许可的情形（合理使用）</h4>
      <p>
        &emsp;&emsp;在仅为如实说明与本基金会及旗下项目（群）相关的情况、而不作为商标用于指示商品或服务来源的前提下，您可以基于商标法下的“合理使用”有限度地使用本基金会品牌，无须本基金会的事先许可。
      </p>
      <p>
        &emsp;&emsp;请注意，商标的“合理使用”在使用目的、使用方式上应是善意、合理且必须的，不应导致相关公众对于您与本基金会及旗下项目（群）之间的关系产生误解，包括不应明示或暗示本基金会及旗下项目（群）工作委员会赞助、认可或支持您的公司、产品或服务等。通常商标的“合理使用”仅限于在真实的事实陈述中以非突出的文字形式使用商标，而不使用包含字体设计和/或图形的商标。
      </p>
      <div>
      </div>
      <p>
        &emsp;&emsp;在您合理使用本基金会品牌时，请您同时以适当方式注明该相关商标为本基金会的商标，比如在使用商标的同一页面中注明：“【相关商标™/相关商标&reg;】
        是开放原子开源基金会享有权益的合法商标。”如果您不确定某一商标是否已在您拟使用的国家/地区注册，请您通过本基金会品牌页面查询。
      </p>
      <h4>1.2.本基金会默认许可的情形</h4>
      <p>
        &emsp;&emsp;在遵守本指南（如使用规范、禁用情形等）前提下，本基金会默认许可您在以下非商业使用情形下，以文字和/或标准样式的形式，善意使用本基金会品牌：
      </p>
      <p>
        &emsp;&emsp;（1）当您在非商业用途的网页上设置直接跳转至本基金会及旗下项目（群）官方网站的超链接时，可以使用对应商标的文字和/或标准样式作为链接按钮。
      </p>
      <p>
        &emsp;&emsp;（2）当您在非商业用途的宣传物料中、为介绍本基金会及旗下项目（群）的相关事实，可以使用对应商标的文字和/或标准样式。
      </p>
      <p>
        &emsp;&emsp;（3）当您为非商业目的制作20件以内的T恤、帽子等常见文化周边产品时，可以使用对应商标的文字和/或标准样式。
      </p>
      <h4>1.3.须经本基金会许可的情形</h4>
      <p>
        &emsp;&emsp;在前述合理使用及默认许可情形之外，您使用本基金会品牌应当经过本基金会许可，尤其包括但不限于以下情形：
      </p>
      <ul>
        <li>
          <p>
            在产品、服务上使用，如：在包装或装潢上使用本基金会品牌，明示或暗示基金会及相关项目工作委员会赞助、认可或支持您的公司、产品或服务。
          </p>
        </li>
        <li>
          <p>
            在会议、赛事、活动中使用，如：在海报或展板中使用本基金会品牌，明示或暗示本基金会或旗下项目（群）工作委员会指导、主办、协办、承办、支持您的会议、赛事、活动等。
          </p>
        </li>
        <li>
          <p>
            在公司、机构的名称中使用，如：以本基金会品牌作为机构名称的一部分。
          </p>
        </li>
        <li>
          <p>
            在社交媒体账号、名称中使用，如：以本基金会品牌作为对外公示的账号名称的一部分。
          </p>
        </li>
        <li>
          <p>
            在域名、网站页面中使用，如：以本基金会品牌作为域名的一部分，或在网页中展示本基金会品牌。
          </p>
        </li>
        <li>
          <p>在证书、名片上使用，如：在证书、名片上展示本基金会品牌。</p>
        </li>
        <li>
          <p>
            在出版物、宣传材料（用于商业目的）中使用，如：在出版物封面或封底、或在机构宣传手册等材料中使用本基金会品牌。
          </p>
        </li>
        <li>
          <p>
            在文化周边产品上使用，如：在对外销售的、或在商业宣传过程中发放的T恤、帽子等常见文化周边产品上使用本基金会或旗下项目（群）商标。
          </p>
        </li>
      </ul>
      <p>
        &emsp;&emsp;您应在实际使用本基金会品牌前经申请取得本基金会的商标使用书面许可。邮件主题应为“品牌使用申请-【具体商标】”，邮件正文应包含如下信息：
      </p>
      <ul>
        <li>拟使用人（请提供个人真实姓名或法人全称）</li>
        <li>拟使用情形（请描述您使用本基金会品牌的具体情形）</li>
        <li>拟使用方式（请上传您拟使用的所有情形相关的设计图或示意图）</li>
        <li>拟使用范围</li>
        <li>拟使用期限（并请根据实际情况说明使用期限的必要性）</li>
      </ul>
      <p>
        &emsp;&emsp;经基金会书面确认许可使用的，商标使用人应按照其邮件申请中所述的使用情形、使用方式、使用范围及使用期限使用相应商标。
      </p>
      <h4>1.4.禁止使用的情形</h4>
      <p> &emsp;&emsp;禁止以与本指南要求不符的方式使用或引用本基金会品牌。</p>
      <p> &emsp;&emsp;禁止以任何诽谤、贬损的方式使用本基金会品牌。</p>
      <p> &emsp;&emsp;禁止在任何虚假或误导性宣传中使用本基金会品牌。</p>
      <p>
        &emsp;&emsp;禁止使用容易与本基金会品牌造成混淆的标识、广告语、宣传口号等。
      </p>
      <h4>2.使用规范</h4>
      <p>
        &emsp;&emsp;（1）如您获得本基金会品牌使用的默认许可或书面许可，请您下载本基金会品牌的标准样式进行规范使用。以标准样式使用商标时，不得移除、扭曲或篡改商标的任何元素，如：不得与任何其他字母或单词相结合，不得使用复数或所有格形式，不得缩写或使用连字符，不得改变颜色等。如须对标准式样进行缩放，必须保留原有的比例。
      </p>
      <p>
        &emsp;&emsp;（2）您不应突出使用本基金会品牌超过您自己公司、产品或服务商标。
      </p>
      <p>
        &emsp;&emsp;（3）在使用时，请您同时以适当方式注明该相关商标为本基金会的商标，比如在使用商标的同一页面中注明：“【相关商标™/相关商标®】是开放原子开源基金会享有权益的合法商标。”
      </p>
      <p>
        &emsp;&emsp;（4）本基金会品牌中的注册商标，在使用时应加注商标符号&reg;；未注册商标，在使用时应加注商标符号™。如果您不确定某一商标是否已在您拟使用的国家/地区注册，请您通过本基金会品牌页面查询。
      </p>
      <p>
        &emsp;&emsp;（5）请注意，本基金会旗下项目（群）可能对其项目（群）品牌的使用提出进一步要求。请您访问基金会旗下各项目（群）品牌使用指南进一步了解该项目（群）商标的使用指南。
      </p>
      <h4>3.声明</h4>
      <p>
        &emsp;&emsp;本基金会不对本基金会品牌的使用做出任何明示或暗示的保证，包括但不限于：本基金会品牌不侵犯任何第三方知识产权的保证、本基金会品牌任何待决商标申请均可获得注册商标保护的保证等。
      </p>
      <p>
        &emsp;&emsp;使用本基金会品牌的第三方同意承担使用本基金会品牌的活动或产品相关索赔的所有责任，并承诺使本基金会及旗下各项目（群）、本基金会的贡献者免于承担任何此类索赔相关责任。
        本指南的任何内容（含示例）不影响本基金会依法享有的任何权益和主张。
      </p>
      <h4>4.更新</h4>
      <p>
        &emsp;&emsp;本基金会可能不定期修订，并在本基金会官方网站（www.openatom.cn）发布本指南更新版本。请您在使用、申请使用本基金会品牌前进行确认符合最新版本的指南。
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.document-page {
  width: 1200px;
  margin: 40px auto;
}

a {
  color: inherit;
  text-decoration: none;
}

.under {
  text-decoration: underline;
  cursor: pointer;
}

.under:hover {
  color: red;
  text-decoration: underline;
}

.smallHand {
  cursor: pointer;
}
</style>
